// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"3cf9e7366d724a1f","1060":"b2272768e376cc06","1221":"080ae3e4e94dcdf4","3602":"0cefd2d8b9f59099","4937":"79f96e5347fbd6a1","7547":"f930955b5f9540da","8486":"77a42dee8c435fe6"}[chunkId] + ".css";
};